/**
 * Initialises the component when passed an element
 *
 * @param {HTMLNode} rootElement The component dom node
 */
export default function(rootElement) {
  if (!rootElement) {
    return;
  }

  const head = rootElement.querySelector('[data-role="select-head"]');
  const body = rootElement.querySelector('[data-role="select-body"]');
  const current = rootElement.querySelector('[aria-current="true"]');

  // if there is a widget
  const widgets = rootElement.querySelectorAll('[data-role="sdc-select-widget"]');
  const widgetbutton = rootElement.querySelector('[data-role="sdc-select-widget-button"]');

  function toggle(close, focus) {
    head.setAttribute('aria-expanded', !close);
    body.setAttribute('aria-hidden', close);

    if (close && focus) {
      head.focus();
    }
  }

  if (head) {
    head.addEventListener('click', (event) => {
      event.preventDefault();
      toggle(head.getAttribute('aria-expanded') === 'true', true);
    });
  }

  if (current) {
    current.addEventListener('click', (event) => {
      event.preventDefault();
      toggle(true, true);
    });
  }

  document.body.addEventListener('click', (event) => {
    if (!rootElement.contains(event.target)) {
      toggle(true, false);
    }
  });

  if (widgets && widgetbutton) {
    widgetbutton.onclick = () => {
      const expanded = widgetbutton.getAttribute('aria-expanded') === 'true';
      const toggletext = widgetbutton.getAttribute('data-toggle-text');

      widgetbutton.setAttribute('data-toggle-text', widgetbutton.textContent);
      widgetbutton.setAttribute('aria-expanded', !expanded);
      widgetbutton.textContent = toggletext;

      widgets[0].setAttribute('aria-hidden', !expanded);
      widgets[1].setAttribute('aria-hidden', expanded);
    };
  }
}
